module.exports = __webpack_public_path__ + "img/0a7a4b380c61aec518012a4b72d5341e.3ef9e4ce.png";